<div class="col-sm-12 no-padding animated fadeIn">
  <h3>
    Beneficiário/Antendido
    <small>Preencha as informações necessárias</small>

    <a class="btn btn-default btn-flat btn-sm pull-right" routerLink="/execucao/visualizar/beneficiarios/listar" *ngIf="editandoVinculo || editandoBeneficiario">
      <i class="fa fa-reply"></i>&nbsp;Voltar lista de usuários</a>
  </h3>

  <h3 *ngIf="editandoVinculo">
    <b class="text-light-blue">{{beneficiarioAtendido.nome}}</b>
  </h3>

  <hr>

  <div class="col-md-12">

    <ul class="timeline">

      <li class="time-label">
        <span class="bg-red">Etapa 1</span>
      </li>
      <li>
        <i class="fa fa-clone bg-blue"></i>
        <div class="timeline-item">

          <h3 class="timeline-header">
            <a (click)="openEtapa1()" style="cursor: pointer;" *ngIf="!editandoBeneficiario">1 - VERIFICAÇÃO DE CPF</a>
            <a (click)="openEtapa1()" style="cursor: pointer;" *ngIf="editandoBeneficiario">1 - Etapa não necessário na edição de benefiário/atendido.</a>
          </h3>

          <div class="timeline-body" *ngIf="etapa1">

            <div class="ui-g">
              <div class="ui-g-12 ui-md-6 ui-fluid">
                <label>CPF:</label>
                <input type="text" class="form-control" mask="000.000.000-00" [(ngModel)]="beneficiarioAtendido.cpf"
                  placeholder="Digite apenas números" [disabled]="disbledCpf">
              </div>

            </div>
          </div>

          <div class="timeline-footer" *ngIf="etapa1">
            <a class="btn btn-primary btn-sm" (click)="confereCpfBeneficiario()">Verificar e continuar</a>
          </div>
        </div>
      </li>


      <li class="time-label" *ngIf="demaisEtapasShow">
        <span class="bg-red">Etapa 2</span>
      </li>
      <li *ngIf="demaisEtapasShow">
        <i class="fa fa-clone bg-blue"></i>
        <div class="timeline-item">

          <h3 class="timeline-header">
            <a (click)="openEtapa2()" style="cursor: pointer;">2 - DEFINIÇÃO DE IDENTIFICAÇÃO</a>
          </h3>

          <div class="timeline-body" *ngIf="etapa2">

            <h2><small class="text-muted">CPF definido:</small> 
              <b class="text-light-blue">{{beneficiarioAtendido.cpf | mask: '000.000.000-00'}}</b></h2>
            <hr>

            <div class="form-group col-sm-9">
              <label>Nome</label>
              <input type="text" class="form-control" [(ngModel)]="beneficiarioAtendido.nome" placeholder="Nome">
            </div>

            <div class="form-group col-sm-3">
              <div class="ui-g-12 ui-fluid" style="padding: 0;">
                <label>Sexo</label>
                <p-select name="Sexo" [options]="sexo" [(ngModel)]="beneficiarioAtendido.sexo"
                  required></p-select>
              </div>
            </div>

            <div class="form-group col-sm-6">
              <label>Nome da Mãe</label>
              <input type="text" class="form-control" [(ngModel)]="beneficiarioAtendido.nomeMae"
                placeholder="Nome da Mãe">
            </div>

            <div class="form-group col-sm-6">
              <label>Nome do Pai</label>
              <input type="text" class="form-control" [(ngModel)]="beneficiarioAtendido.nomePai"
                placeholder="Nome do pai">
            </div>


            <div class="form-group col-sm-4">
              <label>RG</label>
              <input type="text" class="form-control" [(ngModel)]="beneficiarioAtendido.rg" placeholder="RG">
            </div>

            <div class="form-group col-sm-4">
              <label>Data de Nascimento</label>
              <input type="date" class="form-control" [(ngModel)]="beneficiarioAtendido.dataNascimento">
            </div>

            <div class="form-group col-sm-4">
              <div class="ui-g-12 ui-fluid" style="padding: 0;">
                <label>Naturalidade</label>
                <p-select name="naturalidade" [options]="estados"
                  [(ngModel)]="beneficiarioAtendido.naturalidade" required></p-select>
              </div>
            </div>

            <div class="form-group col-sm-4">
              <div class="ui-g-12 ui-fluid" style="padding: 0;">
                <label>Estado Cívil</label>
                <p-select name="estadoCivil" [options]="estadoCivil"
                  [(ngModel)]="beneficiarioAtendido.estadoCivil" required></p-select>
              </div>
            </div>


            <div class="form-group col-sm-4">
              <div class="ui-g-12 ui-fluid" style="padding: 0;">
                <label>Profissão</label>
                <p-select name="profissao" [options]="profissoes"
                  [(ngModel)]="beneficiarioAtendido.profissao" required></p-select>
              </div>
            </div>

            <div class="form-group col-sm-4">
              <div class="ui-g-12 ui-fluid" style="padding: 0;">
                <label>Formação</label>
                <p-select name="formacao" [options]="escolaridade"
                  [(ngModel)]="beneficiarioAtendido.escolaridade" required></p-select>
              </div>
            </div>

            <div class="form-group col-sm-6">
              <label>Renda Familiar</label>
              <input type="text" class="form-control"  placeholder="R$ 0.000,00" currencyMask
              [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }">
            </div>

            <div class="form-group col-sm-6">
              <label>Data de Entrada</label>
              <input type="date" class="form-control" >
            </div>

          </div>

          <div class="timeline-footer" *ngIf="etapa2">
            <a class="btn btn-primary btn-sm" (click)="openEtapa3()">Próximo</a>
          </div>
        </div>
      </li>



      <li class="time-label" *ngIf="demaisEtapasShow">
        <span class="bg-red">Etapa 3</span>
      </li>
      <li *ngIf="demaisEtapasShow">
        <i class="fa fa-clone bg-blue"></i>
        <div class="timeline-item">

          <h3 class="timeline-header">
            <a (click)="openEtapa3()" style="cursor: pointer;">3 - DEFINIÇÃO DE ENDEREÇO</a>
          </h3>

          <div class="timeline-body" *ngIf="etapa3">
            <div class="form-group col-sm-4">
              <label>CEP</label>
              <input type="text" class="form-control" [(ngModel)]="beneficiarioAtendido.cep" placeholder="CEP"
                mask="00000-000" (focusout)="getEnderecoCep($event, 'cidadao')">
            </div>

            <div class="form-group col-sm-8">
              <label>Cidade</label>
              <input type="text" class="form-control" [(ngModel)]="beneficiarioAtendido.cidade" placeholder="Cidade"
                readonly="readonly">
            </div>

            <div class="form-group col-sm-12">
              <label>Endereço</label>
              <input type="text" class="form-control" [(ngModel)]="beneficiarioAtendido.endereco" placeholder="Endereço">
            </div>

            <div class="form-group col-sm-6">
              <label>Bairro</label>
              <input type="text" class="form-control" [(ngModel)]="beneficiarioAtendido.bairro" placeholder="Bairro">
            </div>

            <div class="form-group col-sm-6">
              <label>Estado</label>
              <input type="text" class="form-control" [(ngModel)]="beneficiarioAtendido.estado" placeholder="Estado"
                readonly="readonly">
            </div>
          </div>

          <div class="timeline-footer" *ngIf="etapa3">
            <a class="btn btn-primary btn-sm" (click)="openEtapa4()">Próximo</a>
          </div>
        </div>
      </li>

      <li class="time-label" *ngIf="demaisEtapasShow">
        <span class="bg-red">Etapa 4</span>
      </li>
      <li *ngIf="demaisEtapasShow">
        <i class="fa fa-clone bg-blue"></i>
        <div class="timeline-item">

          <h3 class="timeline-header">
            <a (click)="openEtapa4()" style="cursor: pointer;">4 - DEFINIÇÃO DE CONTATO</a>
          </h3>

          <div class="timeline-body" *ngIf="etapa4">

            <div class="form-group col-sm-12">
              <label>E-mail</label>
              <input type="email" class="form-control" [(ngModel)]="beneficiarioAtendido.email" placeholder="E-mail">
            </div>


            <div class="form-group col-sm-4">
              <label>Celular</label>
              <input type="text" class="form-control" [(ngModel)]="beneficiarioAtendido.celular" placeholder="Celular"
                mask="(00) 0 0000-0000">
            </div>

            <div class="form-group col-sm-2">
              <label><i class="fa fa-fw fa-whatsapp"></i> Whatsapp</label>
              <label class="container-checkbox">
                <input type="checkbox" name="whats" value="whats" (click)="confereCelular($event)">
                <span class="checkmark" style="margin-top: 5px;"></span>
              </label>
            </div>

            <div class="form-group col-sm-3">
              <label>Telefone Comercial</label>
              <input type="text" class="form-control" [(ngModel)]="beneficiarioAtendido.telefoneComercial"
                placeholder="Telefone Comercial " mask="(00) 0 0000-0000">
            </div>

            <div class="form-group col-sm-3">
              <label>Telefone Residencial</label>
              <input type="text" class="form-control" [(ngModel)]="beneficiarioAtendido.telefoneResidencial"
                placeholder="Telefone Residencial" mask="(00) 0 0000-0000">
            </div>



          </div>

          <div class="timeline-footer" *ngIf="etapa4">
            <a class="btn btn-primary btn-sm" (click)="openEtapa5()">Próximo</a>
          </div>
        </div>
      </li>

      <li class="time-label" *ngIf="demaisEtapasShow">
        <span class="bg-red">Etapa 5</span>
      </li>
      <li *ngIf="demaisEtapasShow">
        <i class="fa fa-clone bg-blue"></i>
        <div class="timeline-item">
          <h3 class="timeline-header">
            <a (click)="openEtapa5()" style="cursor: pointer;">5 - SALVAR</a>
          </h3>

          <div class="timeline-body" *ngIf="etapa5">
            <div class="col-md-12">
              <h3>Confime todas as informações se estão corretas antes de salvar.</h3>
              <button (click)="salvar()" class="btn btn-success btn-sm">Salvar</button>
              <br>
              <br>
            </div>
          </div>

          <div class="timeline-footer" *ngIf="etapa5">
            <a class="btn btn-primary btn-sm" (click)="openEtapa4()">VOLTAR</a>
          </div>
        </div>
      </li>


    </ul>
  </div>
</div>